module.exports = __webpack_public_path__ + "img/bg-type04-pc.9db282fb.png";